import ScrollLockManager from '../../../managers/scroll-lock';
import { empty } from "../../../util/dom-helpers";

export default class Hubspot {

  static javaScriptLoadState = {
    UNLOADED: 'unloaded',
    LOADING: 'loading',
    LOADED: 'loaded',
  }

  static endPoint = '/api/forms/hubspot?type=TYPE&thirdParty=THIRD_PARTY';

  constructor(index, isModal) {
    let uniqueAttributeName = '';
    if (isModal) {
      uniqueAttributeName = `data-content-modal-${index}`;
    } else {
      uniqueAttributeName = `data-content-page-form-${index}`;
    }
    this.uniqueAttributeName = uniqueAttributeName;
    this.cachedFormMarkup = {};
    this.closeButton = undefined;
    this.content = undefined;
    this.contentMutationObserver = undefined;
    this.hubspotJavaScriptState = Hubspot.javaScriptLoadState.UNLOADED;
    this.modal = undefined;
    this.form = undefined;
    this.formLoaded = false;
    this.hubspotJavaScriptUrl = document.getElementById('HubspotApi')
      ? document.getElementById('HubspotApi').value
      : 'https://js.hsforms.net/forms/v2.js';

    if (this.hubspotJavaScriptUrl) {
      this.initHubspot();
    }
  }

  async initHubspot() {
    this.onHubspotButtonClick = this.onHubspotButtonClick.bind(this);
    this.onModalCloseClick = this.onModalCloseClick.bind(this);
    this.onFormReady = this.onFormReady.bind(this);
    this.onContentMutation = this.onContentMutation.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.setFormStyles = this.setFormStyles.bind(this);
    this.contentMutationObserver = new MutationObserver(this.onContentMutation);
    window.__hubspot = this; // leave in for now, while we ensure all is working ok

    await this.loadHubspotJavaScript();
  }


  onHubspotButtonClick = (formId, portalId) => (event) => {
    setTimeout(() => {
      event.preventDefault();
      this.openHubspotForm(formId, portalId, false);
    }, 0)
  }


  openHubspotForm(formId, portalId, inPageFormElement) {
    if (!this.content) {
      this.initHubspotContainer(inPageFormElement);
    }

    if (this.content) {
      empty(this.content);
    }

    if (!inPageFormElement) {
      this.insertSpinner();
    }

    this.onFormReady(formId);

    if (inPageFormElement) {
      this.formDestination = inPageFormElement.dataset.formDestination;
      this.formType = inPageFormElement.dataset.formType;
      this.formStyles = inPageFormElement.dataset.formStyle;
    }

    if (this.hubspotJavaScriptState !== Hubspot.javaScriptLoadState.LOADED) {
      this.initHubspot().then(() => {
        this.populateHubspotContainer(formId, portalId, inPageFormElement);
        return;
      })
    }

    this.populateHubspotContainer(formId, portalId, inPageFormElement);
  }

  initHubspotContainer(inPageFormElement) {
    let hubspotContainer;

    if (!inPageFormElement) {
      hubspotContainer = document.createElement('div');
      hubspotContainer.classList.add('Modal');
      hubspotContainer.setAttribute('data-modal', 'true');
      hubspotContainer.innerHTML = `
        <div class="Modal_veil" data-modal-close-target="true"></div>
        <div class="Modal_panel">
          <header class="Modal_header">
            <button class="Modal_closeButton" data-modal-close-target="true"></button>
          </header>
          <main class="Modal_main HubSpotForm" data-hubspot-content="true">
            <div class="Spinner"></div>
          </main>
        </div>
      `;
      document.body.appendChild(hubspotContainer);
      this.content = hubspotContainer.querySelector('[data-hubspot-content]');
      this.inPageForm = false;
      this.closeTargets = [...document.querySelectorAll('[data-modal-close-target]')];
      if (this.closeTargets.length > 0) { 
        this.closeTargets.forEach(target => target.addEventListener('click', this.onModalCloseClick));
      }
    } else {
      hubspotContainer = inPageFormElement;
      hubspotContainer.style = this.formStyles;
      this.content = hubspotContainer;
      this.inPageForm = true;
    }

    this.hubspotContainer = hubspotContainer;
    this.content.setAttribute(this.uniqueAttributeName, 'true');
  }

  loadHubspotJavaScript() {
    // Check if we've already imported
    if (window.hubspt) {
      return;
    }
    return new Promise((resolve, revoke) => {
      this.hubspotJavaScriptState = Hubspot.javaScriptLoadState.LOADING;
      let script = document.querySelector(`script[src="${this.hubspotJavaScriptUrl}"]`);
      if (!script) {
        script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.hubspotJavaScriptUrl;
        document.head.appendChild(script);
      };
      script.addEventListener('load', () => {
        this.hubspotJavaScriptState = Hubspot.javaScriptLoadState.LOADED;
        resolve();
      });
      script.addEventListener('error', (errorEvent) => {
        this.hubspotJavaScriptState = Hubspot.javaScriptLoadState.UNLOADED;
        revoke();
      });
    });
  }

  onContentMutation(mutations) {
    if (!this.formLoaded) return;
    [...mutations].forEach((mutation) => {
      [...mutation.addedNodes].forEach((node) => {
        const formId = node.dataset.formId;
        if (formId) {
          this.cachedFormMarkup[formId] = node;
          this.contentMutationObserver.disconnect();
          this.onFormReady(formId);
        }

        if (node.classList.contains('hs-form-iframe')) {
          throw Error('Hubspot form is being supplied as an iFrame, this is not supported.');
        }
      });
    });
  }

  populateHubspotContainer(formId, portalId, isInPage) {
    if (this.cachedFormMarkup[formId]) {
      if (this.form) {
        this.form.removeEventListener('submit', this.onFormSubmit);
      }
      empty(this.content);
      this.content.appendChild(this.cachedFormMarkup[formId]);
    } else {
      this.contentMutationObserver.observe(this.content, { childList: true });
      const hbsptTarget = `[${this.uniqueAttributeName}]`;
      if (window && window.hbspt && window.hbspt.forms) {
        window.hbspt.forms.create({
          portalId,
          formId,
          target: hbsptTarget,
          onFormReady: () => {
            this.formLoaded = true;
            this.onFormReady(formId, isInPage);
          }
        });
      }
    }
  }

  onFormReady(formId, isInPage) {
    if (!this.inPageForm) {
      this.hubspotContainer.classList.add('Modal-open');
      ScrollLockManager.lock(this);
    } else {
      this.setFormStyles();
    }
    if (this.form) {
      this.form = this.content.querySelector('form');
      this.form.addEventListener('submit', this.onFormSubmit);
    }

    if (!this.content) return;
    setTimeout(() => {
      // Make sure IDs and For attributes are unique, so if we have the multiple 
      // copies of the same form on a page, they don't clash.
      this.cleanUpIDsAndFors(this.content, isInPage);
      // save cached markup so we don't request it every time
      this.cachedFormMarkup[formId] = this.content.firstChild;
    }, 0)
  }

  cleanUpIDsAndFors = (content, isInPage) => {
    if (!content) return;
    this.setUniqueAttributes('[id]', 'id', content, isInPage);
    this.setUniqueAttributes('label', 'htmlFor', content, isInPage);
  }

  setUniqueAttributes = (selector, attribute, content, isInPage) => {
    const clashingElements = content.querySelectorAll(selector);
    if (clashingElements) {
      clashingElements.forEach((element) => {
        element[attribute] = `${element[attribute]}${isInPage ? '-embed' : ''}`;
      });
    }
  }

  insertSpinner() {
    const spinner = document.createElement("div");
    spinner.classList.add("Spinner");
    this.content.appendChild(spinner);
  }

  removeSpinners = () => {
    const spinners = [...document.querySelectorAll('.Spinner')];
    spinners.forEach((spinner) => spinner.remove());
  }

  onModalCloseClick() {
    setTimeout(() => {
      this.removeSpinners();
      this.formLoaded = false;
      this.hubspotContainer.classList.remove('Modal-open');
      ScrollLockManager.release(this);
    }, 0)
  }

  getInputLabel(inputId) {
    let label = '';
    const labels = [...document.getElementsByTagName('label')];
    const inputLabel = labels.find(label => label.htmlFor === inputId);
    if (inputLabel) {
      label = inputLabel.innerText;
    }
    return label;
  }

  onFormSubmit() {
    // Submit after stack to ensure all Hubspot validation has run
    setTimeout(() => {
      const inputs = [...this.form.querySelectorAll('.hs-input')];

      if (this.form.querySelector('.invalid')) {
        console.info('Hubspot form validation error!');
        return;
      }

      let thirdParties = '';
      if (this.inPageForm && this.formDestination) {
        thirdParties = this.formDestination;
      } else {
        inputs.forEach(input => {
          if (input.name === 'third_party') {
            thirdParties = input.value;
          }
        });
      }

      let type = '';
      if (this.inPageForm && this.formType) {
        type = this.formType;
      } else {
        inputs.forEach(input => {
          if (input.name === 'lmt_id') {
            type = input.value;
          }
        });
      }

      let submitted = this.getSubmittedValues(inputs);

      if (this.inPageForm) {
        submitted = {
          ...submitted,
          page_url: window.location.href
        }

        let questions = [];
        inputs.forEach(input => {
          if (input.name.toLowerCase().indexOf('question') !== -1) {
            const key = this.getInputLabel(input.id);
            const questionObject = {
              key: key,
              value: input.value,
            }
            questions.push(questionObject);
          }
        });

        if (questions.length > 0) {
          submitted = {
            ...submitted,
            questions: questions
          }
        }
      }

      let url = Hubspot.endPoint.replace('TYPE', type);
      url = url.replace('THIRD_PARTY', thirdParties);
      let headers = new Headers();
      headers.set('Content-Type', 'application/json');
      return fetch(url, {
        method: 'post',
        body: JSON.stringify(submitted),
        headers: headers
      });
    }, 0);
  }

  getSubmittedValues(inputs) {
    var submitted = {};
    inputs.forEach(function(component) {
      switch (component.type) {
        case 'checkbox':
          if (!submitted[component.name]) {
            submitted[component.name] = [];
          }
          if (component.checked) {
            submitted[component.name].push(component.value);
          } else {
            submitted[component.name].push('');
          }
          break;
        case 'radio':
          if (!submitted[component.name]) {
            submitted[component.name] = '';
          }
          if (component.checked) {
            if (component.value.toLowerCase() == 'yes') {
              submitted[component.name] = true;
            } else if (component.value.toLowerCase() == 'no') {
              submitted[component.name] = false;
            } else {
              submitted[component.name] = component.value;
            }
          }
          break;
        case 'select-multiple':
          submitted[component.name] = Array.from(component.options).map(function(option) {
            return option.value;
          });
          break;
        default:
          submitted[component.name] = component.value
      }
    });

    submitted.timestamp = this.currentDate();
    submitted.fullName = `${submitted.contact_title ? submitted.contact_title + ' ' : ''}${submitted.firstname} ${submitted.lastname}`;

    return submitted;
  };

  currentDate() {
    var current = new Date();
    var date = "".concat(current.getDate(), "-").concat(current.getMonth() + 1, "-").concat(current.getFullYear());
    var time = "".concat(current.getHours(), ":").concat(current.getMinutes());
    var currentDateTime = "".concat(date, " ").concat(time);
    return currentDateTime;
  }

  setFormStyles() {
    const inlineFormStyles = this.content.dataset.formStyle;
    if (inlineFormStyles !== '' && !this.inPageForm) {
      const formElement = this.content.querySelector('form');
      formElement.setAttribute('style', inlineFormStyles);
    }

    const buttonColour = this.content.dataset.formButtonColour;
    const buttonWidth = this.content.dataset.formButtonWidth;
    const headingSize = this.content.dataset.formHeadingSize;
    const radioButtonFloat = this.content.dataset.formRadioButtonFloat.toLowerCase() === 'true';
    const buttonTextColour = this.content.dataset.formButtonTextColour;

    const formButton = this.content.querySelector('.hs-button');
    if (formButton && buttonColour !== '') {
      formButton.style.backgroundColor = `#${buttonColour}`;
    }

    if (formButton && buttonWidth !== '') {
      const actionsElement = this.content.querySelector('.actions');
      actionsElement.style.display = 'flex';
      actionsElement.style.justifyContent = 'center';
      formButton.style.width = `${buttonWidth}px`;
    }

    if (formButton && buttonTextColour !== '') {
      formButton.style.color = `#${buttonTextColour}`;
    }

    const formHeading = this.content.querySelector('h2');
    if (formHeading && headingSize !== '') {
      formHeading.style.fontSize = `${headingSize}px`;
    }

    if (radioButtonFloat) {
      const radioButtonListContainers = [...this.content.querySelectorAll('.hs-fieldtype-radio')];

      radioButtonListContainers.forEach(radioButtonListContainer => {
        const radioButtonLists = [...radioButtonListContainer.querySelectorAll('.inputs-list')];

        radioButtonLists.forEach(radioButtonList => {
          radioButtonList.style.display = 'flex';
          radioButtonList.style.flexFlow = 'row wrap';

          const radioButtonLabels = [...radioButtonList.querySelectorAll('.hs-form-radio-display')];

          radioButtonLabels.forEach(radioButtonLabel => {
            radioButtonLabel.style.marginRight = '1rem';
          });
        });
      });
    }
  }
}
